export default {
  setModelingServiceData(state, tree) {
    state.modelingServiceData = tree
  },
  setSelectedService(state, count) {
    state.modelingSelectedService = count
  },
  setSelectedServiceDetails(state, count) {
    state.modelingSelectedServiceDetails = count
  },
  setModelingLogs(state, params) {
    state.modelingLogs = {
      ...state.modelingLogs,
      [params.id]: {
        log: params.log,
        error: params.error
      }
    }
  },
  setModelingSound(state, data) {
    state.modelingSound = data
    localStorage.setItem('modelingSound', data)
  },
  setModelingSelectedSound(state, data) {
    state.modelingSelectedSound = data
    localStorage.setItem('modelingSelectedSound', data)
  },
  setModelingNewWorkspaceCreated(state, data) {
    state.modelingNewWorkspaceCreated = data
  },
  setModelingNeedSystemLimits(state, data) {
    state.modelingNeedSystemLimits = state.modelingNeedSystemLimits + data
  },
  setModelingSystemLimits(state, params) {
    state.modelingSystemLimits = {
      ...state.modelingSystemLimits,
      [params.id]: {
        ...state.modelingSystemLimits[params.id],
        ...params.value
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modeling/mutations.js